import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select, Divider, Drawer } from 'antd';
import './style.scss';
import UserActions from '@Actions/userActions';
import { v4 as uuidv4 } from 'uuid';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import PaymentTermForm from '../../Admin/AdminConfiguration/PaymentTerm/PaymentTermForm';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const SelectPaymentTerm = ({
  onChange, selectedPaymentTerm, disabled, title, hideTitle, containerClassName, inputClassName, labelClassName, placeholder, isFilter,
  org, getOrg, user, customStyle, showAddPaymentTerm, dropdownAlign, callback,
}) => {
  const [showNewPaymentTermModal, setShowNewPaymentTermModal] = useState(false);

  useEffect(() => {
    getOrg(user?.tenant_info?.org_id);
  }, []);

  const paymentTerms = org?.organisation?.[0]?.default_payment_terms || [];

  const selectedDays = () => paymentTerms?.map((item) => item.due_days);

  return (
    <div className="payment-terms__wrapper">
      <div className={containerClassName}>
        <Drawer
          open={showNewPaymentTermModal}
          width="360px"
          mask
          onClose={() => setShowNewPaymentTermModal(false)}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '315px' }}>
              <H3Text text="Add New Payment Term" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewPaymentTermModal(false)} />
            </div>
          </div>
          <div className="create-po__new-vendor-wrapper">
            <PaymentTermForm
              callback={(value) => {
                getOrg(user?.tenant_info?.org_id);
                setShowNewPaymentTermModal(false);
                callback(value);
              }}
              paymentTerms={paymentTerms}
              selectedDays={() => selectedDays()}
            />
          </div>
        </Drawer>
        {!hideTitle && (
          <div className={labelClassName || 'orgFormLabel'}>
            {title || 'Payment Terms'}
          </div>
        )}
        <div className={inputClassName}>
          <PRZSelect
            value={selectedPaymentTerm}
            filterOption={false}
            disabled={disabled}
            onChange={(value) => onChange(value === 'All' ? 'All' : paymentTerms?.filter((paymentTerm) => paymentTerm?.due_days === value)?.[0])}
            placeholder={placeholder}
            style={customStyle || {
              borderRadius: '4px',
              height: '28px',
              width: '100%',
              padding: '0px',
            }}
            dropdownRender={
              showAddPaymentTerm ? (menu) => (
                <React.Fragment>
                  {menu}
                  <Divider style={{ margin: '0px' }} />
                  <div className="add__payment-term" onClick={() => setShowNewPaymentTermModal(true)}>
                    + Add Payment Term
                  </div>
                </React.Fragment>
              ) : false
            }
          >
            {isFilter && (
              <Option key={0} value="All">
                Select Payment Terms
              </Option>
            )}
            {
              paymentTerms?.map((item) => (
                <Option key={item?.index} value={item?.due_days}>
                  {item?.due_days === 0 ? 'Due on Delivery' : `${item?.due_days} Days`}
                </Option>
              ))
            }

          </PRZSelect>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),
});

SelectPaymentTerm.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  getOrg: PropTypes.func,
  placeholder: PropTypes.any,
  selectedPaymentTerm: PropTypes.any,
  disabled: PropTypes.bool,
  isFilter: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  showAddPaymentTerm: PropTypes.any,
  customStyle: PropTypes.any,
  dropdownAlign: PropTypes.any,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectPaymentTerm));
